import React from 'react'

function Healthy() {
  return (
<>
    <div className='healthy'>Healthy</div>
    <h2 className='warning'>COMING SOON</h2>
    </>
  )
}

export default Healthy